import React from "react";

export const Loader = () => {
    return <div className="h-100 d-flex justify-content-center align-items-center">
        <h1>Loading...</h1>
    </div>
}
